import { useCallback, useLayoutEffect } from 'react';
import { usePreventScroll } from './usePreventScroll';
import { useVisualViewport } from './useVisualViewport';
export const useDialog = ({ allowPinchZoom, canDismissOnEsc, isModal, isOpen, onDismiss, ref, }) => {
    const handleClose = useCallback(() => {
        if (ref.current instanceof HTMLDialogElement &&
            typeof ref.current.close === 'function' &&
            ref.current.open) {
            onDismiss();
            ref.current.close();
        }
    }, [onDismiss, ref]);
    const handleOpen = useCallback(() => {
        if (ref.current instanceof HTMLDialogElement &&
            typeof ref.current.showModal === 'function' &&
            !ref.current.open) {
            if (isModal) {
                ref.current.showModal();
            }
            else {
                ref.current.show();
            }
        }
    }, [isModal, ref]);
    const handleClick = useCallback((event) => {
        if (isModal && ref.current instanceof HTMLDialogElement) {
            const { clientX, clientY } = event;
            const el = ref.current.firstElementChild;
            if (el) {
                const { bottom, left, right, top } = el.getBoundingClientRect();
                if (clientX < left ||
                    clientX > right ||
                    clientY < top ||
                    clientY > bottom) {
                    event.preventDefault();
                    event.stopPropagation();
                    handleClose();
                }
            }
        }
    }, [handleClose, isModal, ref]);
    const handleKeyDown = useCallback((event) => {
        if (canDismissOnEsc && event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            handleClose();
        }
    }, [canDismissOnEsc, handleClose]);
    useLayoutEffect(() => {
        if (isOpen) {
            handleOpen();
        }
        else {
            handleClose();
        }
    }, [handleClose, handleOpen, isOpen]);
    useLayoutEffect(() => {
        const dialog = ref.current;
        if (dialog instanceof HTMLDialogElement) {
            const handleCancel = (event) => {
                event.preventDefault();
                if (canDismissOnEsc) {
                    handleClose();
                }
            };
            dialog.addEventListener('cancel', handleCancel);
            return () => {
                dialog.removeEventListener('cancel', handleCancel);
            };
        }
        return undefined;
    }, [canDismissOnEsc, handleClose, ref]);
    usePreventScroll({ allowPinchZoom, isOpen });
    useVisualViewport();
    return {
        handleClick,
        handleClose,
        handleKeyDown,
    };
};
//# sourceMappingURL=useDialog.js.map